import { DashboardState } from '../types';

export const DASHBOARD_STATE_UPDATED = 'DASHBOARD_STATE_UPDATED';

export interface DashboardStateUpdatedAction {
    type: typeof DASHBOARD_STATE_UPDATED;
    payload: DashboardState;
}

// Action Creators

export const dashboardStateUpdatedFromWebsocket: (payload: DashboardState) => DashboardStateUpdatedAction = (
    payload,
) => {
    return {
        type: DASHBOARD_STATE_UPDATED,
        payload,
    };
};
